import Sortable from "sortablejs/modular/sortable.core.esm.js"

import * as $ from "jquery"

export default function ingredientsSortable(updateUrl) {
  const _url = updateUrl

  function reorderIngredients() {
    let ingredientsIds = ""

    $.each($(".ingredient-list li"), function () {
      ingredientsIds =
        ingredientsIds + "&item_ids[]=" + $(this).data("ingredient-id")
    })

    $.ajax({
      url: _url,
      data:
        ingredientsIds +
        "&authenticity_token=" +
        encodeURIComponent(window.App.authenticityToken),
      type: "POST",
      success() {
        App.Scripts.partners.displayFlash("Ingredients reordered")
      },
      error() {
        App.Scripts.partners.displayFlash(
          "There has been an error reordering the ingredients, try again!",
          "error"
        )
      },
    })
  }

  const ingredientsEl = document.getElementById("ingredient-input-list")
  return Sortable.create(ingredientsEl, {
    animation: 150,
    onUpdate: reorderIngredients,
  })
}
